import { inject } from "@angular/core";
import { CanActivateFn, RedirectCommand, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { isPending } from "@nll/datum/Datum";
import { isInitial, isSuccess } from "@nll/datum/DatumEither";
import { filter, map } from "rxjs/operators";
import { getGrandOpening, selectGrandOpening } from "../ngrx/myqq";

export const grandOpeningGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const store$ = inject(Store);
  const storeNumber = route.params["storenumber"] as string;

  store$.dispatch(getGrandOpening.pending(storeNumber));

  return store$.select(selectGrandOpening).pipe(
    filter((res) => !isPending(res) && !isInitial(res)),
    map(
      (result) =>
        isSuccess(result) ||
        new RedirectCommand(router.parseUrl("/404"), {
          skipLocationChange: true,
        })
    )
  );
};
